import getWithToken from "./base/get-with-token";

const getDeviceStatsCustomerNodata = (date, searchData) =>
  getWithToken(`/dashboard/device-stats-customer-nodata?date=${date}`)({
    ...searchData,
  });

export default getDeviceStatsCustomerNodata;
